import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/src/app/terms-of-service/loading.js");
